/* Shared state for product, sticky and asynchronously loaded recommendation buttons. */
(function () {
  var seed = document.getElementById('TbcCartVariantIds');
  if (!seed || window.tbcCartButtonStateReady) return;
  window.tbcCartButtonStateReady = true;

  var selector = 'button.add-to-cart, button.tbc-comp-btn';
  var records = new Map();
  var variants = new Set(JSON.parse(seed.textContent).map(String));
  var pending = new Set();
  var presentLabel = '✓ Dans votre panier';
  var revision = 0;
  var refreshing = null;
  var root = (window.Shopify && window.Shopify.routes.root) || '/';
  var sticky = document.getElementById('TbcStickyCartBtn');
  var primary = document.querySelector('.product-single__form button[name="add"], ' +
    '.product-single__form .add-to-cart, button.add-to-cart');
  var checkoutStates = new Map();
  var addErrors = new Map();

  function variantId(record) {
    return String(new FormData(record.form).get('id') || '');
  }

  function attribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function toggle(element, name, enabled) {
    if (element.classList.contains(name) !== enabled) element.classList.toggle(name, enabled);
  }

  function render(record) {
    var button = record.button;
    var id = variantId(record);
    var busy = pending.has(id) || button.classList.contains('btn--loading');
    var present = variants.has(id);
    var text = record.label.textContent.trim();
    if (text && text !== presentLabel) record.originalLabel = text;
    var nextLabel = present ? presentLabel : record.originalLabel;
    if (record.label.textContent !== nextLabel) record.label.textContent = nextLabel;
    toggle(button, 'tbc-cart-button--present', present);
    toggle(button, 'tbc-cart-button--loading', busy);
    attribute(button, 'aria-busy', String(busy));
    attribute(button, 'aria-disabled', String(busy || button.disabled));
    attribute(button, 'aria-label', busy ? 'Ajout au panier en cours' :
      present ? 'Dans votre panier. Ouvrir le panier' : record.originalAria || nextLabel);
    if (record.iconPath) {
      attribute(record.iconPath, 'd', present ? 'M5 12l4 4L19 6' : 'M12 5v14M5 12h14');
    }
  }

  function syncCheckout() {
    var checkout = document.querySelector('#CartDrawer .cart__checkout');
    if (!checkout) return;
    if (pending.size) {
      if (!checkoutStates.has(checkout)) checkoutStates.set(checkout, checkout.disabled);
      checkout.disabled = true;
      attribute(checkout, 'aria-busy', 'true');
    } else if (checkoutStates.has(checkout)) {
      checkout.disabled = checkoutStates.get(checkout);
      checkout.removeAttribute('aria-busy');
      checkoutStates.delete(checkout);
    }
  }

  function renderAll() {
    records.forEach(function (record, button) {
      if (!button.isConnected) {
        record.observer.disconnect();
        records.delete(button);
      } else render(record);
    });
    syncCheckout();
  }

  function openCart() {
    if (document.getElementById('CartDrawer')) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    } else window.location.assign(root + 'cart');
  }

  function guard(record, event) {
    var id = variantId(record);
    var busy = pending.has(id) || record.button.classList.contains('btn--loading');
    if (!busy && !variants.has(id)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!busy) openCart();
  }

  function register(button) {
    var form = button.closest('form');
    if (!form || records.has(button) || !form.querySelector('[name="id"]')) return;
    var label = button.querySelector('[data-add-to-cart-text], .tbc-comp-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'tbc-cart-state-label';
      while (button.firstChild) label.appendChild(button.firstChild);
      button.appendChild(label);
    }
    var record = { button: button, form: form, label: label,
      originalLabel: label.textContent.trim(), originalAria: button.getAttribute('aria-label'),
      iconPath: button.querySelector('.tbc-comp-plus path') };
    records.set(button, record);
    button.dataset.tbcCartStateReady = 'true';
    button.addEventListener('click', function (event) { guard(record, event); }, true);
    form.addEventListener('submit', function (event) { guard(record, event); }, true);
    form.addEventListener('change', function () { setTimeout(function () { render(record); }, 0); });
    record.observer = new MutationObserver(function () { render(record); });
    record.observer.observe(button, { attributes: true, attributeFilter: ['class', 'disabled'],
      childList: true, subtree: true, characterData: true });
    render(record);
  }

  function scan(scope) {
    if (scope.matches && scope.matches(selector)) register(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(register);
  }

  if (sticky) sticky.addEventListener('click', function (event) {
    var record = records.get(primary);
    if (record) guard(record, event);
  }, true);
  document.addEventListener('variant:change', function () { setTimeout(renderAll, 0); });
  document.addEventListener('recommendations:loaded', function (event) {
    scan(event.detail && event.detail.section || document);
  });
  new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      change.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
    });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });

  function setCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    revision += 1;
    variants = new Set(cart.items.filter(function (item) { return item.quantity > 0; })
      .map(function (item) { return String(item.variant_id || item.id); }));
    renderAll();
  }

  function refresh() {
    if (refreshing) return refreshing;
    var startedAt = revision;
    refreshing = fetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) { if (startedAt === revision) setCart(cart); })
      .catch(function () { /* Keep the last confirmed state on a failed refresh. */ })
      .finally(function () { refreshing = null; });
    return refreshing;
  }

  document.addEventListener('tbc:cart-pending', function (event) {
    var id = String(event.detail.variantId);
    if (event.detail.pending) pending.add(id);
    else pending.delete(id);
    renderAll();
  });
  document.addEventListener('ajaxProduct:added', function (event) {
    var product = event.detail && event.detail.product;
    if (!product) return;
    revision += 1;
    variants.add(String(product.variant_id || product.id));
    addErrors.delete(String(product.variant_id || product.id));
    renderErrors();
    renderAll();
  });
  document.addEventListener('cart:updated', function (event) { setCart(event.detail && event.detail.cart); });
  // Do not leave for checkout while a product explicitly requested by the shopper is queued.
  document.addEventListener('submit', function (event) {
    if (pending.size && event.target.id === 'CartDrawerForm') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  function renderErrors() {
    var drawer = document.querySelector('#CartDrawer.drawer--is-open .drawer__scrollable');
    if (!drawer) return;
    var error = drawer.querySelector('[data-tbc-cart-add-error]');
    if (!addErrors.size) {
      if (error) error.remove();
      return;
    }
    if (!error) {
      error = document.createElement('p');
      error.dataset.tbcCartAddError = '';
      error.className = 'errors';
      error.setAttribute('role', 'alert');
      drawer.prepend(error);
    }
    error.textContent = Array.from(addErrors.values()).join(' ');
  }
  document.addEventListener('ajaxProduct:error', function (event) {
    var sourceError = event.target.querySelector && event.target.querySelector('.errors');
    if (!sourceError) return;
    var button = event.target.querySelector(selector);
    var record = records.get(button);
    var title = record && record.originalAria ? record.originalAria.replace(/^Ajouter /, '').replace(/ au panier$/, '') : '';
    addErrors.set(String(new FormData(event.target).get('id')), (title ? title + ' : ' : '') + sourceError.textContent);
    renderErrors();
  });
  document.addEventListener('drawerOpen.CartDrawer', function () { setTimeout(renderErrors, 0); });
  // The initial render already refreshes once; pageshow only needs a read on bfcache return.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });

  scan(document);
  refresh();
})();
